import axios from "axios";
const pcCoursePassages = {
    namespaced: true,
    state: {
        selection: {
            id_course: null,
            id_point: null,
        },
        passages_course: null,
        passages_point: null,
    },
    mutations: {
        setSelectedCourse(state, course) {
            state.selection.id_point = null;
            state.selection.id_course = course.id;
        },
        setSelectedPoint(state, point) {
            state.selection.id_course = null;
            state.selection.id_point = point.id;
        }
    },
    actions: {
        async fetchCoursesPassages({ commit, state, rootState }, routeParams = {}) {
            const response = await axios.get(rootState.base_url + "/pc_course/passages_course/get.php?id_live=" + rootState.module.id_live + "&id_course=" + state.selection.id_course);
            state.passages_course = response.data;
        },
        async fetchPointsPassages({ commit, state, rootState }, routeParams = {}) {
            const response = await axios.get(rootState.base_url + "/pc_course/passages_point/get.php?id_live=" + rootState.module.id_live + "&id_point=" + state.selection.id_point);
            state.passages_point = response.data;
        }
    },
    getters: {
        selection(state) {
            return state.selection;
        },
        selectedType(state) {
            if (!state.selection.id_course && !state.selection.id_point) {
                return null;
            }
            return state.selection.id_course ? "course" : "point";
        },
        noTypeSelected(state) {
            return !state.selection.id_course && !state.selection.id_point;
        },
        selectedCourse(state) {
            return state.selection.id_course;
        },
        selectedPoint(state) {
            return state.selection.id_point;
        },
        passages_course(state) {
            return state.passages_course;
        },
        passages_point(state) {
            return state.passages_point;
        }
    }
}

export default pcCoursePassages;